import { type SHARED_COMPONENTS_EN_US } from '../../translations/en-US'
import { makeUseMessage, makeUseMessages } from '../../hooks/intl/intl.factories'

type MessageIds = keyof typeof SHARED_COMPONENTS_EN_US

export const useMessage = makeUseMessage<MessageIds>()
export const useMessages = makeUseMessages<MessageIds>()
